import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { updateAudit } from "lib/@offline/queued-audits"
import { getAuditsByReferenceIdAndType } from "routes/audit/controller/get-audits-by-reference-id"

// The review-decision port. Inline accept/reject buttons depend only on this contract
// and never on how a decision is persisted or read. The default implementation records
// the decision as a customSchedule audit and reads it back per task; other review modes
// (e.g. authoring amends) bind their own `reviewDecisions` provider into context.
export const auditReviewDecisions = {
    record: recordAuditDecision,
    useDecision: useAuditDecision,
}

export function useReviewDecisions() {
    const { reviewDecisions } = useBoundContext()
    return reviewDecisions ?? auditReviewDecisions
}

function recordAuditDecision({ auditId, referenceId, shortDescription, payload }) {
    return updateAudit({
        auditId,
        type: "customSchedule",
        referenceId,
        shortDescription,
        longDescription: shortDescription,
        payload,
    })
}

function useAuditDecision({ referenceId, groupReviewId, taskId }) {
    const filter = { "payload.groupReviewId": groupReviewId, "payload.taskId": taskId }
    const rows = getAuditsByReferenceIdAndType.useResults(referenceId, "customSchedule", filter)
    return rows && rows.length ? rows[0] : null
}
